import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('TROUBLESHOOTING_ANSWERS');
export const TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CONSTANTS
);
